import { ChevronDownIcon, TriangleDownIcon } from "@primer/octicons-react";
import { Button, SelectPanel } from "@primer/react";
import { useEffect, useMemo, useState } from "react";
import { useCommonContext } from "../../contexts/common";
import { trangThaiGiayToApi } from "../../api/trangThaiGiayToApi";

interface IComboboxTrangThaiGiayToProps {
  isReadonly?: boolean;
  value?: number;
  onValueChanged: (id: number, data?: any) => void;
  className?: string;
  isShowClearButton?: boolean;
  preText?: string;
  width?: string | number;
  stylingMode?: "outlined" | "filled" | "underlined";
}

const ComboboxTrangThaiGiayTo = (props: IComboboxTrangThaiGiayToProps) => {
  const [TrangThaiGiayTo, setTrangThaiGiayTo] = useState<any[]>([]);
  const [selectdItem, setSelectdItem] = useState<any>(props.value || null);
  const [open, setOpen] = useState(false);
  const [filter, setFilter] = useState("");
  const { translate } = useCommonContext();
  const dataSource = useMemo(() => {
      const items = TrangThaiGiayTo.map((x) => {
        return {
          id: x.id,
          text: `${x.trang_thai}`,
        };
      });
      var itemSelected = items.find(x => x.id === props.value);
      // if(items.length > 0 && itemSelected === undefined)
      //   setSelectdItem(items[0]);
      // else
        setSelectdItem(items.find(x => x.id === props.value));
      return [...items];
  }, [TrangThaiGiayTo]);

  const filteredItems = useMemo(() => {
    return dataSource.filter((item) =>
      item.text.toLowerCase().includes(filter.toLowerCase())
    );
  }, [dataSource, filter]);

  useEffect(() => {
    handleGetTrangThaiGiayToAsync();
  }, []);

  const setSelected = (selecteds: any) => {
    setSelectdItem(selecteds);
    if (selecteds) props.onValueChanged(selecteds.id, selecteds);
  };

  const handleGetTrangThaiGiayToAsync = async () => {
    const res = await trangThaiGiayToApi.selectAll();
    if (res.is_success) {
      setTrangThaiGiayTo(res.data);
    }
  };

  return (
    <SelectPanel
      renderAnchor={({
        children,
        "aria-labelledby": ariaLabelledBy,
        ...anchorProps
      }) => (
        <Button
           trailingAction={ChevronDownIcon}
          aria-labelledby={` ${ariaLabelledBy}`}
          {...anchorProps}
          sx={{
            width: "100%",
          }}
        >
          <p
            style={{
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {children || translate("Chọn trạng thái giấy tờ")}
          </p>
        </Button>
      )}
      title={""}
      placeholderText="Search"
      open={open}
      onOpenChange={setOpen}
      items={filteredItems}
      selected={selectdItem}
      onSelectedChange={setSelected}
      onFilterChange={setFilter}
      showItemDividers={true}
      overlayProps={{ width: "small", height: "medium" }}
    />
  );
};

export default ComboboxTrangThaiGiayTo;
